import React, { useMemo } from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import useLayerContext from 'contexts/layerContext';

function LayerDivitionCombo(props) {
  const { onChange, ignoreExcluded = false, lockDivition = false } = props;
  const { divitions, filteredDivitions, selectedDivition, setSelectedDivition } = useLayerContext();

  function handleChange(e) {
    let divition = divitions.find((divition) => divition.id === parseInt(e.target.value));
    setSelectedDivition(divition);
    if (onChange !== undefined) {
      onChange();
    }
  }

  return (
    <FormControl fullWidth margin="normal" size="small" disabled>
      <InputLabel shrink>Grupo Capa</InputLabel>
      <Select
        value={selectedDivition?.id || ''}
        onChange={handleChange}
        disabled={lockDivition === true}
      >
        {(ignoreExcluded === true ? divitions : filteredDivitions).map((divition) => {
          return (
            <MenuItem key={divition.id} value={divition.id}>
              {divition.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default LayerDivitionCombo;
